import React from "react";

import EventNavigation from "./EventNavigation/EventNavigation";
import BlogsHome from "./BlogsHome/BlogsHome";
import EventHome from "./EventHome/EventHome";
import EventAbout from "./EventAbout/EventAbout";
import MobileApp from "./MobileApp/MobileApp";
import MobileAppPopup from "./MobileAppPopup/MobileAppPopup";
import PropTechTimesHome from "./PropTechTimesHome/PropTechTimesHome";
import WhoItsBuiltFor from "./WhoItsBuiltFor/WhoItsBuiltFor";
import Form from "./Form/Form";
import Footer from "./Footer/Footer";
import "./events_page.css";

const EventPage = () => {
    return (
        <>
            <MobileAppPopup />
            <EventNavigation />

            <EventHome />
            <EventAbout />
            <WhoItsBuiltFor />
            <MobileApp />
            <PropTechTimesHome />
            <BlogsHome />
            {/* <EventsGallery /> */}
            <Form />
            <Footer />
        </>
    );
};

export default EventPage;
